/** Team invite landing, accept, wrong-account and verify copy. Part of `UI_STRINGS` - see ui-strings.ts. */
export const UI_INVITE_STRINGS = {
  INVITE: {
    BADGE: "You've been invited to join the My NEXT Raise community.",
    HEADING: 'Accept Your Invitation',
    // Startup admin invite (MYN-311): there is no team yet, they create the startup next.
    STARTUP_ADMIN_SUBTITLE: 'Create your account, then set up your startup profile.',
    CARD_TITLE: 'Personal Information',
    CARD_SUBTITLE: 'Your basic contact and identity details',
    FULL_NAME_LABEL: 'Full Name',
    FULL_NAME_PLACEHOLDER: 'Alex Johnson',
    EMAIL_LABEL: 'Email Address',
    PASSWORD_LABEL: 'Password',
    PASSWORD_PLACEHOLDER: '••••••••',
    CONFIRM_PASSWORD_LABEL: 'Confirm Password',
    COMPANY_NAME_LABEL: 'Company Name',
    LINKEDIN_LABEL: 'LinkedIn Profile',
    LINKEDIN_LABEL_OPTIONAL: '(optional)',
    LINKEDIN_PLACEHOLDER: 'https://linkedin.com/in/username',
    ENCRYPTION_NOTE: 'Your data is encrypted and never shared without consent.',
    CONSENT_LABEL_PREFIX: 'I agree to the ',
    CONSENT_LABEL_LINK: 'Terms and Conditions',
    CONSENT_LABEL_SUFFIX: '.',
    CONSENT_REQUIRED_ERROR: 'You must accept the Terms and Conditions to continue.',
    SUBMIT: 'Submit',
    SUBMITTING: 'Setting up your account…',
    ERROR: 'We could not accept this invite. Please try again.',
    // 409 EMAIL_ALREADY_REGISTERED: a verified account exists for the invited email.
    ERROR_EXISTING_ACCOUNT: 'An account already exists for this email. Sign in to accept this invite.',
    SIGN_IN_TO_ACCEPT: 'Sign in to accept',
    EXPIRED_HEADING: 'This Link Is No Longer Active',
    EXPIRED_BODY:
      'The invite link you followed has either expired or been revoked by the sender. Please reach out to the person who shared this link to request a new one.',
    EXPIRED_CTA: 'Go to My NEXT Raise',
    EXPIRED_FOOTNOTE: 'If you believe this is an error, contact the person who shared this link with you.',
    EXPIRED_PILL_EXPIRED: 'Link Expired',
    EXPIRED_PILL_REVOKED: 'Link Revoked',
    NOT_FOUND_HEADING: 'Invite Not Found',
    NOT_FOUND_BODY: "We couldn't find an invite for this link. Please check the link and try again.",
    ALREADY_ACCEPTED_HEADING: 'Invite Already Used',
    ALREADY_ACCEPTED_BODY: 'This invite link has already been accepted. Log in instead, or ask for a new invite if this was not you.',
  },
  INVITE_ACCEPT_CONFIRM: {
    BADGE: "You've been invited to join",
    TITLE_PREFIX: "You've been invited to join ",
    BODY: 'Accept to join with your existing My NEXT Raise account - no new password needed.',
    CTA: 'Accept Invite',
    ACCEPTING: 'Accepting…',
    ERROR: 'We could not accept this invite. Please try again.',
  },
  INVITE_WRONG_ACCOUNT: {
    HEADING: 'Wrong Account',
    BODY_PREFIX: 'This invite was sent to ',
    BODY_SUFFIX: '. Log out and sign in with that address to accept it.',
    CTA: 'Log Out',
  },
  INVITE_VERIFY: {
    BADGE: 'Security Check - Step 2 of 3',
    HEADING_PREFIX: 'Verify your ',
    HEADING_HIGHLIGHT: 'email',
    SUBTITLE_PREFIX: "We've sent a 6-digit code to",
    SUBTITLE_LINE2: 'Enter the code below to secure your account.',
    SENT_TO_LABEL: 'CODE SENT TO',
    SENT_TO_HINT: 'Check your inbox and spam folder',
    SENT_CHIP: 'Sent',
    SEND_FAILED:
      'We could not send your code right now. Please use Resend Code to try again in a moment.',
    CARD_TITLE: 'Enter Verification Code',
    CARD_SUBTITLE: '6-digit one-time password',
    CODE_LABEL: 'Verification code',
    EXPIRES_NOTE_PREFIX: 'This code expires in ',
    EXPIRES_NOTE_BOLD: '10 minutes',
    EXPIRES_NOTE_SUFFIX: '. Do not share it with anyone.',
    EXPIRES_IN: 'Code expires in',
    NO_CODE: "Didn't receive it?",
    RESEND: 'Resend Code',
    RESENDING: 'Sending…',
    RESENT: 'A new code is on its way if the address is registered.',
    RESEND_ERROR: 'We could not resend the code. Please try again.',
    ERROR_RATE_LIMITED: 'Too many requests. Please wait a moment and try again.',
    BACK: 'Back',
    SUBMIT: 'Verify & Continue',
    SUBMITTING: 'Verifying…',
    ERROR: 'That code is invalid or expired. Please try again.',
    ERROR_INVALID: 'That code is incorrect. Please try again.',
    ERROR_EXPIRED: 'That code has expired. Request a new one.',
    ERROR_LOCKED: 'Too many attempts. Request a new code.',
    ENCRYPTION_NOTE: 'Your data is encrypted and never shared without consent.',
  },
} as const;
